<template>
  <div class="inner t-center">
    <div class="t-title sm mb-l icon">
      <svg width="26" height="39" viewBox="0 0 26 39" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M25.3653 35.244L23.7651 25.9629C22.845 20.7223 18.3245 16.9219 13.0038 16.9219C7.68322 16.9219 3.16268 20.7623 2.24257 25.9629L0.642385 35.244C0.402356 36.6842 1.52251 38.0044 2.96268 38.0044H23.045C24.5252 38.0044 25.6453 36.6842 25.3653 35.244Z"
          fill="#A3ABB6"
        />
        <path
          d="M12.9642 15.2018C17.162 15.2018 20.5651 11.7987 20.5651 7.60089C20.5651 3.40303 17.162 0 12.9642 0C8.76632 0 5.36328 3.40303 5.36328 7.60089C5.36328 11.7987 8.76632 15.2018 12.9642 15.2018Z"
          fill="#A3ABB6"
        />
      </svg>
    </div>
    <div class="t-title sm mb-l header">Travelers on your Trip</div>

    <div class="grid-container">
      <div class="ui-input-wrapper">
        <Dropdown
          class="ui-dropdown-wrapper"
          :value="localValue.adults"
          @change="onValueChange($event, 'adults')"
          category="Adults"
          :options="adultOptions"
        />
      </div>
      <div class="ui-input-wrapper">
        <Dropdown
          class="ui-dropdown-wrapper"
          :value="localValue.children"
          @change="onValueChange($event, 'children')"
          category="Children"
          :options="childrenOptions"
        />
      </div>
      <div class="ui-input-wrapper">
        <Dropdown
          class="ui-dropdown-wrapper"
          :value="localValue.rooms"
          @change="onValueChange($event, 'rooms')"
          category="Rooms, Stay"
          :options="roomOptions"
        />
      </div>
    </div>

    <div class="children-age-selector" v-if="children.length">
      <div class="grid-container child-age" v-for="(child, index) in children" :key="index">
        <div class="ui-input-wrapper">
          <span class="child-name">{{ child }}</span>
          <span class="child-hint">&nbsp;(Select Age)</span>
        </div>
        <div class="ui-input-wrapper">
          <Dropdown
            class="ui-dropdown-wrapper"
            :value="childrenAge[index] || '5'"
            @change="onChildAgeChange($event, index)"
            category="Age of Child"
            :options="ageOptions"
          />
        </div>

        <div class="ui-input-wrapper" v-if="childrenAge[index] === 'Under 2'">
          <Dropdown
            class="ui-dropdown-wrapper"
            :value="childrenSeat[index] || 'In seat'"
            @change="onChildSeatChange($event, index)"
            category="Seated"
            :options="seatingOptions"
          />
        </div>
      </div>
    </div>

    <AmexButton class="btn amex-primary" @click="onClose">Let's go</AmexButton>
  </div>
</template>

<script>
import Dropdown from './travelers-dropdown.vue';
import {AmexButton} from '@mobi-components/amex-bluesky-components';
import {travlersDefaultValue} from './travelers.types';

export default {
  components: {
    Dropdown,
    AmexButton,
  },
  name: 'TravelersFilter',
  props: {
    value: {
      type: Object,
      default: () => ({...travlersDefaultValue}),
    },
  },
  data() {
    return {
      localValue: {...travlersDefaultValue.filter},
      adultOptions: [
        travlersDefaultValue.filter.adults,
        '2 Adults',
        '3 Adults',
        '4 Adults',
        '5 Adults',
        '6 Adults',
        '7 Adults',
        '8 Adults',
        '9 Adults',
      ].map((x) => ({
        label: x,
        value: x,
        key: x,
        disabled: false,
      })),
      childrenOptions: [
        travlersDefaultValue.filter.children,
        '1 Child',
        '2 Children',
        '3 Children',
        '4 Children',
        '5 Children',
        '6 Children',
        '7 Children',
        '8 Children',
        '9 Children',
      ].map((x) => ({
        label: x,
        value: x,
        key: x,
        disabled: false,
      })),
      roomOptions: [travlersDefaultValue.filter.rooms, '2 Rooms', '3 Rooms', '4 Rooms'].map((x) => ({
        label: x,
        value: x,
        key: x,
        disabled: false,
      })),
      ageOptions: ['Under 2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17'].map(
        (x) => ({
          label: x,
          value: x,
          key: x,
          disabled: false,
        }),
      ),
      seatingOptions: ['In Seat', 'In Lap'].map((x) => ({
        label: x,
        value: x,
        key: x,
        disabled: false,
      })),
      childrenAge: {},
      childrenSeat: {},
    };
  },
  mounted() {
    this.localValue = (this.value ? {...travlersDefaultValue, ...this.value} : {...travlersDefaultValue}).filter;
    this.childrenAge = this.value ? this.value.age : travlersDefaultValue.age;
    this.childrenSeat = this.value ? this.value.seating : travlersDefaultValue.seating;
    this.$emit('change', {filter: this.localValue, age: this.childrenAge, seating: this.childrenSeat});
  },
  methods: {
    onValueChange(value, kind) {
      this.localValue = {
        ...this.localValue,
        [kind]: value,
      };
      const numberOfChildren = parseInt(value, 10);
      if (kind === 'children' && !isNaN(numberOfChildren)) {
        for (let i = 0; i < numberOfChildren; i++) {
          this.childrenAge[i] = this.childrenAge[i] || '5';
          this.childrenSeat[i] = this.childrenSeat[i] || 'In Seat';
        }
        for (let i = numberOfChildren; i < 20; i++) {
          delete this.childrenAge[i];
          delete this.childrenSeat[i];
        }
      }
      if (kind === 'children' && isNaN(numberOfChildren)) {
        this.childrenAge = {};
        this.childrenSeat = {};
      }
      this.$emit('change', {filter: this.localValue, age: this.childrenAge, seating: this.childrenSeat});
    },
    onClose() {
      this.$emit('close', {filter: this.localValue, age: this.childrenAge, seating: this.childrenSeat});
    },
    onChildAgeChange(value, index) {
      this.childrenAge = {...this.childrenAge, [index]: value};
      this.$emit('change', {filter: this.localValue, age: this.childrenAge, seating: this.childrenSeat});
    },
    onChildSeatChange(value, index) {
      this.childrenSeat = {...this.childrenSeat, [index]: value};
      this.$emit('change', {filter: this.localValue, age: this.childrenAge, seating: this.childrenSeat});
    },
  },
  computed: {
    children() {
      const numberOfChildren = parseInt(this.localValue.children || 0, 10);
      if (isNaN(numberOfChildren)) {
        return [];
      }
      return new Array(numberOfChildren).fill('Child').map((x, index) => `${x} ${index + 1}`);
    },
  },
};
</script>

<style scoped>
.ui-input-wrapper {
  overflow: hidden;
  display: flex;
  align-items: center;
}

.header {
  margin-bottom: 15px;
}

.grid-container {
  display: grid;
  gap: 15px;
  grid-template-columns: 1fr 1fr 1fr;
}

.ui-dropdown-wrapper {
  --dropdown-border: none;
  padding-left: 20px;
  padding-right: 10px;
  background: #f7f7f7;
  border-radius: 20px;
  color: #071d3b;
}

.btn {
  margin-left: auto;
  appearance: none;
  border: none;
  background: none;
  cursor: pointer;
  margin-top: 30px;
}

.btn.amex-primary {
  background: var(--btn-primary-color, hsl(214, 64%, 48%));
  border-radius: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 118.14%;
  text-align: center;
  letter-spacing: -0.005em;

  color: #ffffff;
  padding: 12px 100px 10px;
}

.btn.amex-primary:hover {
  background: var(--btn-primary-color-active, hsl(214, 64%, 30%));
}

.icon {
  margin-bottom: 15px;
}

.children-age-selector {
  border-top: 1px solid #f1f1f1;
  border-bottom: 1px solid #f1f1f1;
  padding: 16px 0;
  margin: 16px 0;
}

.grid-container.child-age {
  margin-bottom: 10px;
  padding: 0 0 0 16px;
}

.child-hint,
.child-name {
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  color: #333333;
}

.child-name {
  font-weight: 700;
}
</style>
